import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=416f01c5&scoped=true&"
import script from "./myorder.js?vue&type=script&lang=js&"
export * from "./myorder.js?vue&type=script&lang=js&"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=416f01c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f01c5",
  null
  
)

export default component.exports